import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from './local-storage.service';
import { LoggerService } from './logger/logger.service';
import { Router } from '@angular/router';
import { AuthLinksService } from './auth-links.service';
import { CLIENT_REDIRECT_AFTER_AUTH_ROUTES } from '../shared/constants';
import { InAppBrowserAuthService } from './in-app-browser-auth.service';
import { NativeCheckService } from './native-check.service';

@Injectable({
  providedIn: 'root'
})
export class NavigateAfterLoginService {
  public constructor(
    private localStorageService: LocalStorageService,
    private loggerService: LoggerService,
    private router: Router,
    private authLinksService: AuthLinksService,
    private inAppBrowserAuthService: InAppBrowserAuthService,
    private nativeCheckService: NativeCheckService,
  ) { }

  public saveRouteAndAuth(afterAuthRoute: string): void {
    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.REDIRECT_AFTER_LOGIN,
      value: encodeURIComponent(afterAuthRoute)
    });

    this.forceLogin(afterAuthRoute);
  }

  private forceLogin(afterAuthRoute: string) {
  if (CLIENT_REDIRECT_AFTER_AUTH_ROUTES.some(term => afterAuthRoute.includes(term))) {
      if(this.nativeCheckService.isNativePlatform()) {
        this.inAppBrowserAuthService.openInAppBrowser();
      } else {
        window.location.href = this.authLinksService.bcasClientLoginUrl;
      }
    } else {
      throw new Error('Unknown login user for route: ' + afterAuthRoute);
    }
  }

  public checkRedirectAndReloadIfExist(afterAuthRoute: string): void {
    if(this.nativeCheckService.isNativePlatform()) {
      this.loggerService.error('Routing after logout is not supported for native apps!');
    } else {
      if(afterAuthRoute) {
        this.router.navigateByUrl(afterAuthRoute);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.REDIRECT_AFTER_LOGIN);
      }
    }
  }
}
